/* eslint-disable import/no-named-as-default */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable import/no-unresolved */
import React, { useState, useEffect } from 'react'
import { useStaticQuery, graphql } from 'gatsby'
import styled from 'styled-components'
import Loading from 'components/shared/Loading'

// Language
import { getLanguage, isBrowser } from 'services/language'
import { isPossiblePhoneNumber } from 'react-phone-number-input'

// Libraries
import { Formik, Form } from 'formik'

// Steps
import dayjs from 'dayjs'
import Step1 from './Step1'
import Step2 from './Step2'

const StepTitle = styled.h2`
  font-weight: ${(props) => props.theme.font.weight.s};
  color: ${(props) =>
    props.isActive
      ? props.theme.color.text.secondary
      : props.theme.color.background};
  opacity: ${(props) => (props.isActive ? 1 : 0.8)};
  display: ${(props) => (props.isActive ? 'block' : 'none')};

  & > div {
    outline: none;
  }

  @media (min-width: 992px) {
    font-size: ${(props) => props.theme.font.size.xl};
  }

  @media (max-width: 991px) {
    display: ${(props) => (props.isActive ? 'block' : 'none')};
    font-size: ${(props) => props.theme.font.size.xm};
  }
`

const LoadingWrapper = styled.div`
  position: relative;
  height: 500px;
`

const StepBack = styled.div`
  font-size: 16px;
  color: #6b6b6b;
  display: block;
  padding: 0;
  margin-top: 10px;
`

const Quotation = ({
  id,
  fields,
  fieldsSend,
  infoPageId,
  step,
  setStep,
  status,
  setStatus,
}) => {
  const { forms } = useStaticQuery(graphql`
    {
      forms: allGfForm {
        edges {
          node {
            formId
            apiURL
            formFields {
              id
              label
              visibility
              isRequired
              inputName
              type
              description
              choices
              placeholder
            }
          }
        }
      }
    }
  `)

  const { node: form } = forms.edges.filter(
    ({ node: { formId } }) => formId === id
  )[0]

  const [expanded, setExpanded] = useState(0)
  const [data, setData] = useState({})

  useEffect(() => {
    if (typeof localStorage !== 'undefined') {
      const storageData = localStorage.getItem(`quotation-${id}-data`)

      if (storageData) {
        setData(JSON.parse(storageData))
      }

      const storageExpaned = localStorage.getItem(`quotation-${id}-expanded`)

      if (storageExpaned) {
        setExpanded(storageExpaned)
      }
    }
  }, [])

  const setDataLocal = (event) => {
    const newData = { ...data }

    newData[event.target.name] = event.target.value

    if (typeof localStorage !== 'undefined') {
      localStorage.setItem(`quotation-${id}-data`, JSON.stringify(newData))
    }

    setData(newData)
  }

  const setExpandedLocal = (value) => {
    if (typeof localStorage !== 'undefined') {
      localStorage.setItem(`quotation-${id}-expanded`, value)
    }

    setExpanded(value)
  }

  const handleSubmission = async (values) => {
    const formData = new FormData()

    Object.keys(values).forEach((key) => {
      formData.append(key, values[key])
    })

    try {
      if (window && window.dataLayer) {
        if (id === 2) {
          if (parseFloat(expanded) === 0) {
            window.dataLayer.push({ event: 'prijsindicatie-nl' })
          } else {
            window.dataLayer.push({ event: 'prijsindicatie-uitgebreid-nl' })
          }
        } else if (parseFloat(expanded) === 0) {
          window.dataLayer.push({ event: 'prijsindicatie-en' })
        } else {
          window.dataLayer.push({ event: 'prijsindicatie-uitgebreid-en' })
        }
      }

      const request = await fetch(`${form.apiURL}/submissions`, {
        method: 'POST',
        body: formData,
      })

      if (request.ok) {
        setStatus('redirecting')

        await request.json()

        localStorage.removeItem(`quotation-${id}-step`)
        localStorage.removeItem(`quotation-${id}-expanded`)
        localStorage.removeItem(`quotation-${id}-data`)

        if (isBrowser()) {
          window.location.href = `${fieldsSend.redirect_url.url
            }?infoId=${infoPageId}&email=${id === 2 ? values.input_26 : values.input_20
            }`
        }

        return true
      }

      const error = await request.json()
      await setStatus(error)

      return false
    } catch (error) {
      setStatus('error')
      throw error
    }
  }

  const formFields = {}
  const initialValues = {}
  let formFieldsIndex = 1
  let storageData = null

  if (typeof localStorage !== 'undefined') {
    storageData = localStorage.getItem(`quotation-${id}-data`)
  }

  if (storageData) {
    storageData = JSON.parse(storageData)
  }

  form.formFields.forEach((edges) => {
    if (edges.type === 'section') {
      formFieldsIndex = parseFloat(edges.label.split(' ')[1])
    } else {
      if (!formFields[formFieldsIndex]) {
        formFields[formFieldsIndex] = []
      }

      formFields[formFieldsIndex].push(edges)

      if (storageData && storageData[`input_${edges.id}`]) {
        initialValues[`input_${edges.id}`] = storageData[`input_${edges.id}`]
      } else {
        initialValues[`input_${edges.id}`] = ''
      }
    }
  })

  return (
    <Formik
      initialValues={initialValues}
      validate={(values) => {
        const errors = {}

        formFields[step].forEach((edges) => {
          if (
            values[`input_${edges.id}`] !== undefined &&
            values[`input_${edges.id}`] === '' &&
            edges.isRequired
          ) {
            errors[`input_${edges.id}`] =
              getLanguage() === 'nl_NL' ? 'Is verplicht' : 'Is mandatory'
          }

          if (
            values[`input_${edges.id}`] !== undefined &&
            values[`input_${edges.id}`] !== '' &&
            edges.type === 'email' &&
            !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,8}$/i.test(
              values[`input_${edges.id}`]
            )
          ) {
            errors[`input_${edges.id}`] =
              getLanguage() === 'nl_NL'
                ? 'Ongeldig e-mail adres'
                : 'Invalid e-mail address'
          }

          if (
            values[`input_${edges.id}`] !== undefined &&
            values[`input_${edges.id}`] !== '' &&
            edges.type === 'phone' &&
            !isPossiblePhoneNumber(values[`input_${edges.id}`])
          ) {
            errors[`input_${edges.id}`] =
              getLanguage() === 'nl_NL'
                ? 'Ongeldig telefoonnummer, kies een geldig land'
                : 'Invalid phonenumber, choose a valid country'
          }

          if (
            values[`input_${edges.id}`] !== undefined &&
            values[`input_${edges.id}`] !== '' &&
            edges.type === 'date' &&
            !dayjs().isBefore(values[`input_${edges.id}`])
          ) {
            errors[`input_${edges.id}`] =
              getLanguage() === 'nl_NL'
                ? 'Datum moet later zijn dan vandaag'
                : 'Date has to be later than today'
          }
        })

        return errors
      }}
      onSubmit={async (values, { setSubmitting }) => {
        setSubmitting(true)

        const response = await handleSubmission(values)

        if (!response) {
          setSubmitting(false)
        }
      }}
    >
      {({ isSubmitting, setFieldValue, validateForm, handleSubmit }) => {
        if (isSubmitting || status === 'redirecting') {
          return (
            <LoadingWrapper>
              <Loading />
            </LoadingWrapper>
          )
        }

        return (
          <Form method="post" id={`form_${id}`}>
            <div className="d-md-flex align-items-center justify-content-between">
              <StepTitle isActive={parseFloat(step) === 1}>
                <div
                  role="button"
                  onClick={() => {
                    if (parseFloat(step) !== 1) {
                      setStep(1)
                    }
                  }}
                  onKeyPress={() => { }}
                  tabIndex="0"
                >
                  {fields.step_1.title}
                </div>
              </StepTitle>
              <StepTitle isActive={parseFloat(step) === 2}>
                {fields.step_2.title}
                <StepBack
                  role="button"
                  onClick={() => {
                    if (parseFloat(step) !== 1) {
                      setStep(1)
                    }
                  }}
                  tabIndex="-1"
                >
                  Terug naar stap 1
                </StepBack>
              </StepTitle>
            </div>

            <div className="mt-4">
              {parseFloat(step) === 1 && (
                <div>
                  <Step1
                    fields={fields.step_1}
                    formFields={formFields[1]}
                    setExpanded={setExpandedLocal}
                    expanded={expanded}
                    setData={setDataLocal}
                    data={data}
                    setFieldValue={setFieldValue}
                    setStep={setStep}
                    validateForm={validateForm}
                    handleSubmit={handleSubmit}
                  />
                </div>
              )}
              {parseFloat(step) === 2 && (
                <div>
                  <Step2
                    fields={fields.step_2}
                    formFields={formFields[2]}
                    setExpanded={setExpandedLocal}
                    expanded={expanded}
                    setData={setDataLocal}
                    data={data}
                    setFieldValue={setFieldValue}
                    setStep={setStep}
                    validateForm={validateForm}
                    handleSubmit={handleSubmit}
                  />
                </div>
              )}
            </div>
          </Form>
        )
      }}
    </Formik>
  )
}

export default Quotation
